import MojitoServices from 'mojito/services';
import MojitoCore from 'mojito/core';
import BetslipButtonView from './view/index.js';
import { isEmpty } from 'mojito/utils';
import { connect } from 'react-redux';

const UIViewImplementation = MojitoCore.Presentation.UIViewImplementation;
const { selectors: userBonusesSelectors } = MojitoServices.UserBonuses;
const { selectActiveFreeBets } = userBonusesSelectors;
const { utils: BetslipUtils, selectors: betslipSelectors } = MojitoServices.Betslip;
const {
    actions: userSettingsActions,
    types: UserSettingsTypes,
    selectors: { selectOnboarding },
} = MojitoServices.UserSettings;
const { BETSLIP_FREE_BET_HINT } = UserSettingsTypes.ONBOARDING_TYPES;
const { selectBetslipStatus, selectOverask, selectReceipt, selectBetslip, selectInitialized } =
    betslipSelectors;

class BetslipButtonController extends UIViewImplementation {
    constructor(props) {
        super(props);

        this.onCloseFreebetsTip = () => {
            this.closeFreebetsTip();
            this.setState({ showFreebetsTip: false });
        };

        this.onButtonClick = () => {
            const hasBetslipItems = this.props.betslipItemsCount > 0;
            if (hasBetslipItems && this.shouldShowFreebetsTip()) {
                this.closeFreebetsTip();
            }
            this.props.onClick();
        };
    }

    closeFreebetsTip() {
        const { dispatch } = this.props;
        dispatch(
            userSettingsActions.updateOnboardingProgress({
                [BETSLIP_FREE_BET_HINT]: { passed: true },
            })
        );
    }

    shouldShowFreebetsIndication() {
        return !isEmpty(this.props.freeBets) && this.props.enableFreebetsIndication;
    }

    shouldShowFreebetsTip() {
        const showFreebets = this.shouldShowFreebetsIndication();
        return this.props.showFreebetsTip && showFreebets;
    }

    render() {
        // Button is highlighted when we have selections in betslip
        const isHighlighted = this.props.betslipItemsCount > 0;
        return (
            <BetslipButtonView
                onClick={this.onButtonClick}
                disabled={this.props.disabled}
                config={this.config.view}
                isHighlighted={isHighlighted}
                isLoading={this.props.isLoading}
                showImage={this.props.showImage}
                betslipItemsCount={this.props.betslipItemsCount}
                onCloseFreebetsTip={this.onCloseFreebetsTip}
                showFreebetsIcon={this.shouldShowFreebetsIndication()}
                showFreebetsTip={isHighlighted && this.shouldShowFreebetsTip()}
                showOveraskImage={this.props.inOverask}
            >
                {this.props.children}
            </BetslipButtonView>
        );
    }
}

const getBetslipItemsCount = (state, isQuickBetslip) => {
    const receipt = selectReceipt(state);
    const betslip = selectBetslip(state);
    const { bets = [] } = receipt || {};
    const numberOfBetsInReceipt = bets.length;
    const partsInBetslipCount = BetslipUtils.getIndividualBetsCount(betslip);
    const hasBetReceipt = bets.length > 0;

    // Prevent quickly showing 1 before quick betslip receipt is minimized,
    // quick betslip will be cleared anyway.
    if (isQuickBetslip && hasBetReceipt) {
        return 0;
    }

    return hasBetReceipt ? numberOfBetsInReceipt : partsInBetslipCount;
};

const mapStateToProps = (state, ownProps) => ({
    showFreebetsTip: !selectOnboarding(state)[BETSLIP_FREE_BET_HINT]?.passed,
    inOverask: BetslipUtils.isOverask(selectBetslipStatus(state)) || !isEmpty(selectOverask(state)),
    betslipItemsCount: getBetslipItemsCount(state, ownProps.isQuickBetslip),
    isLoading: !selectInitialized(state),
    freeBets: selectActiveFreeBets(state),
});

export default connect(mapStateToProps)(BetslipButtonController);
